/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import LandingPageLayout from '../../components/layouts/LandingPageLayout';
import Image from 'next/image';
import Ideas from '/public/static/5-Ideas.png';
export const meta = {
  author: 'Jens Arre Seip'
};
const MDXLayout = ({children}) => _jsx(LandingPageLayout, {
  mdx: true,
  meta: meta,
  title: "5 tips for å skape nysgjerrighet i klasserommet",
  subTitle: "Her deler jeg noen tips til aktiviteter inspirert av alle de dyktige lærerne vi",
  children: children
});
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h3: "h3",
      strong: "strong",
      p: "p",
      a: "a",
      br: "br",
      em: "em"
    }, props.components);
    return _jsxs(_Fragment, {
      children: [_jsx(Image, {
        src: Ideas
      }), "\n", _jsx(_components.h3, {
        children: _jsx(_components.strong, {
          children: "5 tips for å skape nysgjerrighet i klasserommet"
        })
      }), "\n", _jsx(_components.p, {
        children: "Kritisk tenkning, engasjement og utforskertrang er blant de sentrale verdiene og prinsippene i grunnopplæringen i Norge. Det gjelder for barneskole, ungdomsskole og videregående opplæring, og på tvers av alle fag. Her deler jeg noen tips til aktiviteter inspirert av alle de dyktige lærerne vi prater med i Curipod - takk til dere!"
      }), "\n", _jsx(_components.h3, {
        children: _jsx(_components.strong, {
          children: "Ta et standpunkt"
        })
      }), "\n", _jsx(_components.p, {
        children: "I denne aktiviteten kan du som lærer lage en liste med påstander, f.eks: “Norge burde stanse leting etter olje og gass”, “Demokrati er den eneste gode styreformen”, etc."
      }), "\n", _jsx(_components.p, {
        children: "For hver påstand reiser alle elvene seg opp, og samles i midten av klasserommet. Den ene siden i klasserommet er “For” siden, og den andre er “Mot” siden. Elevene må så velge hvilken side de vil gå til, avhengig av om de er for eller mot påstanden. Det er ikke lov å bli stående i midten. Dette skaper garantert masse bra diskusjon!"
      }), "\n", _jsx(_components.h3, {
        children: _jsx(_components.strong, {
          children: "Digitalt escape room"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["Å lage escape rooms er en super aktivitet for elevene til å utforske, skape og samarbeide. Dette kan gjøres på mange måter, hvor OneNote og Genially er gode verktøy. Her er en guide til hvordan gjøre det i ", _jsx(_components.strong, {
          children: _jsx(_components.a, {
            href: "https://academy.genial.ly/en/pills/how-to-create-escape-games",
            children: "Genially"
          })
        })]
      }), "\n", _jsx(_components.h3, {
        children: _jsx(_components.strong, {
          children: "Hva vet jeg, ønsker jeg å lære, har jeg lært? (VØL)"
        })
      }), "\n", _jsx(_components.p, {
        children: "Når du introduserer et nytt tema kan du bruke Curipod til å bruke VØL-teknikken på en engasjerende måte."
      }), "\n", _jsxs(_components.p, {
        children: ["VØL står for:", _jsx(_components.br, {}), "\n", "V – Hva ", _jsx(_components.em, {
          children: "vet"
        }), " jeg?", _jsx(_components.br, {}), "\n", "Ø – Hva ", _jsx(_components.em, {
          children: "ønsker"
        }), " jeg å lære?", _jsx(_components.br, {}), "\n", "L – Hva har jeg ", _jsx(_components.em, {
          children: "lært"
        }), "?"]
      }), "\n", _jsxs(_components.p, {
        children: ["I starten av timen, bruk Curipod og be elevene først svare på hva de ", _jsx(_components.em, {
          children: "vet"
        }), " om dagens tema, og deretter stille spørsmål til hva de ", _jsx(_components.em, {
          children: "ønsker"
        }), " å lære om dagens tema. Dette gjør elevene oppmerksomme på hva de kan fra før, og de blir nysgjerrige på hva de kan lære om temaet."]
      }), "\n", _jsxs(_components.p, {
        children: ["På slutten av timen kan du igjen bruke Curipod hvor elevene kan svare på hva de har ", _jsx(_components.em, {
          children: "lært"
        }), " i løpet av timen. Kom i gang med Curipod ", _jsxs(_components.strong, {
          children: [_jsx(_components.a, {
            href: "https://curipod.com",
            children: "her"
          }), "."]
        })]
      }), "\n", _jsx(_components.h3, {
        children: _jsx(_components.strong, {
          children: "La elevene lage spørsmål til prøver"
        })
      }), "\n", _jsx(_components.p, {
        children: "Denne aktiviteten ble inspirert av to lærere på Elverum VGS. Prøver er noe mange elever sliter med å motivere seg for. En perfekt strategi for å få til elevmedvirkning, og gode prøver er å be elevene være med å lage spørsmålene til neste prøve. Sett opp en Curipod Live med klassen, og du har 20 gode spørsmål til neste prøve i løpet av et par minutter. Og mye mer motiverte elever!"
      }), "\n", _jsx(_components.h3, {
        children: _jsx(_components.strong, {
          children: "IGP-metoden"
        })
      }), "\n", _jsx(_components.p, {
        children: "IGP står for Individ, Gruppe, Plenum. IGP-metoden legger til rette for dialog der alle får delta aktivt. Det er en velprøvd involveringsmetode som skaper engasjement og passer for de fleste."
      }), "\n", _jsx(_components.p, {
        children: "IGP-metoden går ut på at elevene får mulighet til å diskutere og reflektere rundt et tema. Først alene – Individ. Så sammen med noen få – Gruppe. Til slutt sammen med alle som deltar – Plenum."
      })]
    });
  }
}
export default MDXContent;
